module.exports = __webpack_public_path__ + "static/media/IMG_7242-min.52e109ce.jpg";